// Dummy API service for verification
export interface VerificationResponse {
  success: boolean;
  token?: string;
  message?: string;
}

export interface VerificationRequest {
  pin: string;
}

// Dummy API call that simulates verification
export const verifyPin = async (pin: string): Promise<VerificationResponse> => {
  // Simulate API call delay
  await new Promise(resolve => setTimeout(resolve, 1500));
  
  // Dummy validation logic
  const validPins = ['12345678', '11111111', '00000000'];
  
  if (validPins.includes(pin)) {
    // Generate a dummy token for successful verification
    const token = `dummy-token-${Date.now()}`;
    
    // Store token in localStorage for demo purposes
    localStorage.setItem('authToken', token);
    localStorage.setItem('isAuthenticated', 'true');
    
    return {
      success: true,
      token,
      message: 'Verification successful!'
    };
  } else {
    throw new Error('Invalid PIN. Please enter a valid 8-digit PIN.');
  }
};

// Helper function to check if user is authenticated
export const isUserAuthenticated = (): boolean => {
  const token = localStorage.getItem('authToken');
  const isAuth = localStorage.getItem('isAuthenticated');
  return !!(token && isAuth === 'true');
};

// Helper function to logout
export const logout = (): void => {
  localStorage.removeItem('authToken');
  localStorage.removeItem('isAuthenticated');
};

// Helper function to get auth token
export const getAuthToken = (): string | null => {
  return localStorage.getItem('authToken');
};
